export default "__VITE_ASSET__BlB8XzE1__"